import { render, staticRenderFns } from "./DetailsInfoCard.vue?vue&type=template&id=4deb7e8a&"
import script from "./DetailsInfoCard.vue?vue&type=script&lang=js&"
export * from "./DetailsInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports